import { Link } from "react-router-dom";

function ForgotPassord(){
    return(
        <div>
            目前尚未製作此功能  <Link to="/" className="text-xs underline text-[#5892e9]">回首頁</Link>
        </div>
    );
}

export default ForgotPassord;